function trans (n) {
  if (n > 9) return n;
  else return `0${n}`;
}

const getType1Time = D => { // 現在時間 轉成 2021-12-15 11:30:15
  const d = D || new Date();
  try {
    if (typeof (d) === 'object') return `${d.getFullYear()}-${trans(d.getMonth() + 1)}-${trans(d.getDate())} ${trans(d.getHours())}:${trans(d.getMinutes())}:${trans(d.getSeconds())}`;
    else return '';
  } catch {
    return '';
  }
};

const getType2Time = d => { // 轉成 2021/12/15
  try {
    if (typeof (d) === 'object') return `${d.getFullYear()}/${(d.getMonth() + 1) > 9 ? (d.getMonth() + 1) : `0${d.getMonth() + 1}`}/${d.getDate() > 9 ? d.getDate() : `0${d.getDate()}`}`;
    else return '';
  } catch {
    return '';
  }
};

const getType3Time = d => { // 轉成 2021-12-15
  try {
    if (typeof (d) === 'object') return `${d.getFullYear()}-${(d.getMonth() + 1) > 9 ? (d.getMonth() + 1) : `0${d.getMonth() + 1}`}-${d.getDate() > 9 ? d.getDate() : `0${d.getDate()}`}`;
    else return '';
  } catch {
    return '';
  }
};

const getType4Time = d => { // 轉成 2021-12-15 11:30
  try {
    if (typeof (d) === 'object') return `${d.getFullYear()}-${trans(d.getMonth() + 1)}-${trans(d.getDate())} ${trans(d.getHours())}:${trans(d.getMinutes())}`;
    else return '';
  } catch {
    return '';
  }
};

const returnDate = (t = '') => {
  if ((typeof (t) === 'string') && (t.length > 0)) {
    let text = t;
    while (text.match(' '))text = text.replace(' ', 'T');
    while (text.match('/'))text = text.replace('/', '-');
    return new Date(text);
  } else return '';
};

export { getType1Time, getType2Time, getType3Time, getType4Time, returnDate };
